import { Routes } from '@angular/router';
import { ILanguage } from '@cinetixx/cinetixx-ui';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { NoLangGuard } from './core/guards/no-lang.guard';
import { languagesSnippetsGuard } from './language/core/guards/languages-snippets.guard';

const userLang = JSON.parse(localStorage.getItem('user-lang')) as ILanguage;
const browserLang = navigator.language.split('-')[0];

export const routes: Routes = [
  {
    path: '',
    redirectTo: `${ userLang?.token ?? browserLang ?? environment.fallbackLanguage }/dashboard`,
    pathMatch: 'full',
  },
  {
    path: ':language',
    loadChildren: () => import('./_main/main.routes').then(m => m.MAIN_ROUTES),
    canActivate: [languagesSnippetsGuard]
  },
  {
    path: '**',
    canActivate: [NoLangGuard],
    component: AppComponent
  }
];
